import { seoThemeType } from "../Constants/seo";
export var mapSeoTheme = function mapSeoTheme(seoTheme, collection) {
  var key = seoTheme.toLowerCase();
  return collection[key] || null;
};
var makeLocationInfo = function makeLocationInfo(seoTheme, brands, location) {
  var makeInfo;
  var locationInfo;
  var parts = seoTheme.split('&');
  if ((parts === null || parts === void 0 ? void 0 : parts.length) === 1) {
    var _seoTheme = parts[0];
    makeInfo = mapSeoTheme(_seoTheme, brands);
    if (makeInfo) {
      locationInfo = null;
    } else {
      locationInfo = mapSeoTheme(_seoTheme, location);
    }
  } else if ((parts === null || parts === void 0 ? void 0 : parts.length) === 2) {
    var makeSeoTheme = parts[0];
    var locationSeoTheme = parts[1];
    makeInfo = mapSeoTheme(makeSeoTheme, brands);
    locationInfo = mapSeoTheme(locationSeoTheme, location);
  } else {
    return null;
  }
  return {
    makeInfo: makeInfo,
    locationInfo: locationInfo
  };
};
var generateSeoInfo = function generateSeoInfo(makeInfo, locationInfo) {
  var seoInfoType;
  if (makeInfo && locationInfo) {
    seoInfoType = seoThemeType.makeLocation;
  } else {
    seoInfoType = makeInfo ? seoThemeType.make : seoThemeType.location;
  }
  return Object.assign(Object.assign(Object.assign(Object.assign({}, makeInfo ? {
    make: makeInfo.value,
    makeId: makeInfo.key
  } : {}), locationInfo ? {
    location: locationInfo.value,
    locationId: locationInfo.key
  } : {}), {
    type: seoInfoType
  }), (locationInfo === null || locationInfo === void 0 ? void 0 : locationInfo.lat) && (locationInfo === null || locationInfo === void 0 ? void 0 : locationInfo.lng) ? {
    lat: locationInfo.lat,
    lng: locationInfo.lng
  } : {});
};
var generateAdditionalData = function generateAdditionalData(makeInfo, locationInfo) {
  return Object.assign(Object.assign(Object.assign({}, makeInfo ? {
    make: makeInfo.key
  } : {}), locationInfo ? {
    locationId: locationInfo.key
  } : {}), (locationInfo === null || locationInfo === void 0 ? void 0 : locationInfo.lat) && (locationInfo === null || locationInfo === void 0 ? void 0 : locationInfo.lng) ? {
    lat: locationInfo.lat.toString(),
    lng: locationInfo.lng.toString()
  } : {});
};
export var getSeoInformation = function getSeoInformation(params, config) {
  var _ref = (config === null || config === void 0 ? void 0 : config.sellThematicPages) || {},
    _ref$brands = _ref.brands,
    brands = _ref$brands === void 0 ? {} : _ref$brands,
    _ref$location = _ref.location,
    location = _ref$location === void 0 ? {} : _ref$location,
    showSellThematicPages = _ref.showSellThematicPages;
  if (!showSellThematicPages || !(params === null || params === void 0 ? void 0 : params.seoTheme)) {
    return null;
  }
  var makeLocation = makeLocationInfo(params === null || params === void 0 ? void 0 : params.seoTheme, brands, location);
  if (!makeLocation) {
    return null;
  }
  var makeInfo = makeLocation.makeInfo,
    locationInfo = makeLocation.locationInfo;
  var seoInfo = generateSeoInfo(makeInfo, locationInfo);
  var additionalData = generateAdditionalData(makeInfo, locationInfo);
  return {
    seoInfo: seoInfo,
    additionalData: additionalData
  };
};
export var getThematicTrackingInfo = function getThematicTrackingInfo(params, config) {
  var thematicInfo = getSeoInformation(params, config);
  return (thematicInfo === null || thematicInfo === void 0 ? void 0 : thematicInfo.seoInfo) ? thematicInfo.seoInfo : null;
};
export default {
  getSeoInformation: getSeoInformation,
  getThematicTrackingInfo: getThematicTrackingInfo
};